import { render, staticRenderFns } from "./ArrowUp.vue?vue&type=template&id=cbc4f282&"
import script from "./ArrowUp.vue?vue&type=script&lang=js&"
export * from "./ArrowUp.vue?vue&type=script&lang=js&"
import style0 from "./ArrowUp.vue?vue&type=style&index=0&id=cbc4f282&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports